export enum ResourceId {
  TaxHomeDeclaration = 'tax-home-declaration',
}
